module.exports = __webpack_public_path__ + "img/faucet-drip.0195cc31.svg";